import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: "S'agit-il d'un produit physique ?",
  a: 'Non. SENIOR FITNESS PRO™ est un système 100 % numérique au format PDF, accessible immédiatement après votre achat depuis un ordinateur, une tablette ou un smartphone.'
}, {
  q: 'Ce système convient-il aux professionnels débutants ?',
  a: 'Oui. Il peut être utilisé par des professionnels débutants, mais il a été conçu avant tout pour les coachs et enseignants souhaitant gagner du temps et disposer de ressources professionnelles immédiatement exploitables.'
}, {
  q: "Puis-je l'utiliser avec différents profils de seniors ?",
  a: 'Absolument. Les séances, exercices et planifications sont facilement adaptables selon le niveau, les capacités physiques et les objectifs de chaque groupe.'
}, {
  q: 'Puis-je adapter les contenus à ma façon de travailler ?',
  a: "Bien sûr. Les exercices, séances, programmes et documents sont entièrement personnalisables afin de s'adapter à votre méthode de travail."
}, {
  q: 'Quand vais-je constater les premiers bénéfices ?',
  a: 'La plupart des professionnels gagnent plusieurs heures de préparation dès les premières semaines et se sentent rapidement mieux organisés dans leur travail.'
}, {
  q: 'Le système fonctionne-t-il pour les cours collectifs et individuels ?',
  a: 'Oui. Les séances, circuits et programmes incluent des variantes pour le suivi individuel, les petits groupes et les cours collectifs, avec des adaptations immédiates pour les groupes de niveaux différents.'
}, {
  q: 'Faut-il du matériel particulier ?',
  a: 'Non. Les exercices sont également classés par matériel disponible : poids du corps, chaise, élastiques, petits haltères, ballons ou step, selon ce dont vous disposez dans votre salle.'
}, {
  q: 'Puis-je imprimer les fiches et les planifications ?',
  a: "Oui. Séances, fiches d'évaluation, registres de suivi, check-lists et calendriers sont conçus pour être imprimés et utilisés directement en salle, en association ou en cabinet."
}, {
  q: "S'agit-il d'un paiement unique ou d'un abonnement ?",
  a: "C'est un paiement unique de 27 €. Aucun frais récurrent : vous accédez aux 6 modules et aux 5 Bonus Premium pour toujours."
}, {
  q: 'Les 5 Bonus Premium sont-ils livrés immédiatement ?',
  a: "Oui. Les 5 Bonus Premium sont inclus dans le même accès immédiat envoyé par e-mail après votre achat, sans attente ni étape supplémentaire."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-31" data-mp="2ylicze76hg63">
      <h2 className="text-2xl sm:text-4xl font-display text-center text-navy leading-none mb-4" data-id="element-32" data-mp="2umhslr91y5gz">
        Questions fréquemment posées
      </h2>

      <div className="flex flex-col gap-1.5 max-w-3xl mx-auto" data-id="element-33" data-mp="1n61ze4qu94bq">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.q} className="bg-white border border-gold/30 rounded-lg overflow-hidden" data-id="element-34" data-mp="3uuy2gp0kp3tx" data-mpi={i}>
              <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full px-3.5 py-2.5 text-left flex justify-between items-center gap-3 hover:bg-cream/60 transition-colors" data-id="element-35" data-mp="2o1bae58wbml">
                <span className="font-heading font-bold text-navy text-[13px] sm:text-base leading-snug" data-id="element-36" data-mp="mduui3tw9if7">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-4 h-4 text-petrol shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-37" data-mp="qg83d13xtwg7" />
              </button>
              {isOpen && <p id={`faq-panel-${i}`} className="px-3.5 pb-2.5 text-ink text-[12.5px] sm:text-sm leading-snug" data-id="element-38" data-mp="2s9fq2vlvrgc4">
                  {faq.a}
                </p>}
            </div>;
      })}
      </div>
    </section>;
}